import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatHorizontalStepper } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AppConstant } from 'src/app/constants/app.constant';
import { AuthService } from 'src/app/core/services/auth.service';
import { OrderItemInsertRequest } from 'src/app/models/virtual-store/order-item-insert-request.model';
import { Product } from 'src/app/models/virtual-store/product.model';
import { AccountService } from 'src/app/services/account.service';
import { CommonService } from 'src/app/services/common.service';
import { OrderItemService } from 'src/app/services/order-item.service';
import { VirtualStoreService } from 'src/app/services/virtual-store.service';
import { CreditLineFNB } from 'src/app/models/account/credit-line-fnb.model';

@Component({
  selector: 'app-shopping-cart',
  templateUrl: './shopping-cart.component.html',
  styleUrls: ['./shopping-cart.component.scss']
})
export class ShoppingCartComponent implements OnInit, OnDestroy {
  @ViewChild('stepper', { read: MatHorizontalStepper, static: false }) stepper: MatHorizontalStepper;
  dni: string = '';
  fullName: string = '';
  accountDataFetchedSubscription: Subscription;
  ubigeoFnbSuscription:Subscription;
  unsubscribe$ = new Subject();
  creditLineFNB: CreditLineFNB = new CreditLineFNB();
  constructor(private activatedRoute: ActivatedRoute,
    private virtualStoreService: VirtualStoreService,
    private commonService: CommonService,
    private orderItemService: OrderItemService,
    private accountService: AccountService,
    private authService: AuthService,
    private router: Router
  ) {
    this.creditLineFNB = this.authService.getCreditLineFNB();
    this.accountDataFetchedSubscription = this.commonService.accountDataFetchedAnnounced
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(accountData => {
      this.loadShoppingCardExternal();
      this.creditLineFNB = this.authService.getCreditLineFNB();
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  loadShoppingCardExternal(): void {
    this.activatedRoute.queryParams
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(params => {
      if (params.prdct) {
        this.processProduct(Number(params.prdct));
      } else {
        this.router.navigate(['/ofivirtual/tienda/carrito']);
      }
    });
  }

  processProduct(productId: number): void {
    this.virtualStoreService.getProduct(productId)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(responseProduct => {
      if (responseProduct.valid) {
        if(this.isProductValidByCategory(responseProduct.data)) {
          const orderItem = new OrderItemInsertRequest();
          orderItem.productId = productId;
          orderItem.count = 1;
          orderItem.clientCode = this.accountService.getStorageBasicData().clientCode;
          orderItem.monthlyPaymentCount = 1;
          orderItem.documentType=this.authService.getBasicData().documentType;
          orderItem.documentNumber=this.authService.getBasicData().documentNumber;
    
          this.orderItemService.addPendingOne(orderItem).subscribe(responseOrder => {
            if (responseOrder.valid) {
              this.virtualStoreService.announceCreditLineUpdated(responseOrder.data.creditLine)
              this.virtualStoreService.announceOrderUpdated(responseOrder.data.pendingOrderItemList);                               
            }
            this.router.navigate(['/ofivirtual/tienda/carrito']);
          });
        } else {
          Swal.fire('', `No cuenta con línea disponible para comprar productos de la categoría ${responseProduct.data.category.description}`, 'warning');
          this.loadShoppingCardLast();
        }
      } else {
        this.router.navigate(['/ofivirtual/tienda/carrito']);
      }
    });
  }

  loadShoppingCardLast(): any {
    let isFnb=this.creditLineFNB.isCreditLineFNB;
    this.orderItemService.listPendingOnes(this.authService.getBasicData().clientCode,isFnb)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(response => {              
      this.virtualStoreService.announceOrderUpdated(response.data);  
      this.router.navigate(['/ofivirtual/tienda/carrito']);
    });
  }

  isProductValidByCategory(product: Product): boolean {
    if(this.authService.getCreditLineFNB() && this.authService.getCreditLineFNB().isCreditLineFNB) {
      return product.category.codeFilter === AppConstant.FNB;
    } else {
      return product.category.codeFilter !== AppConstant.FNB;
    }
  }

  next() {
    this.stepper.selected.completed = true;
    this.stepper.next();
  }
  goToSecondStep($event: any) {
    this.dni = $event.dni;
    this.fullName = $event.fullName;
    this.next();
  }

}
